// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__links":"Footer_footer__links__rIy9u","footer__links-item-label":"Footer_footer__links-item-label__8e8Hf"};